// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__ZBwhw","large":"styles_large__MbFw4"};